import { List } from "../../../@types/list";
import {
  AnsweringClient,
  IUserResponse,
  SearchAllUsersParams,
} from "../../../clients/answeringClient";
import { describeApiError, isExpiredSession } from "../../../utils/apiError";

export interface AllUsersControllerDelegate {
  didGetAllUsers(response: List<IUserResponse>): void;
  didPromoteToReseller(): void;
  didFailPromoteToReseller(message: string): void;
  applicationShouldLogout(): void;
  genericError(message: string): void;
}

export class AllUsersController {
  constructor(
    private delegate: AllUsersControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async searchUsers(accessToken: string, params: SearchAllUsersParams) {
    try {
      const response = await this.answeringClient.searchAllUsers(
        accessToken,
        params
      );
      this.delegate.didGetAllUsers(response.data);
    } catch (error: any) {
      console.error("Failed to search all users:", error);
      const errorMessage =
        error?.response?.data?.message ||
        "Ocorreu um erro ao buscar os usuários. Tente novamente.";
      this.delegate.genericError(errorMessage);
    }
  }

  public async promoteToReseller(
    accessToken: string,
    userUid: string,
    hasRetried = false
  ): Promise<void> {
    try {
      await this.answeringClient.promoteToReseller(accessToken, userUid);
      this.delegate.didPromoteToReseller();
    } catch (error: any) {
      if (isExpiredSession(error) && !hasRetried) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        return this.promoteToReseller(newTokens.accessToken, userUid, true);
      }
      this.delegate.didFailPromoteToReseller(
        describeApiError(error, "Falha ao promover o usuário.")
      );
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
